export const INVOICE_LINK_EMAIL_FIELD = 'email'
export const INVOICE_LINK_CONTACT_FIELD = 'contactUuid'
